import { AfterViewInit, Component, Inject, Input, LOCALE_ID, OnInit, TemplateRef, ViewChild  } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { Subject } from 'rxjs';
import _ from 'lodash';


@Component({
  selector: 'ngx-schedule',
  templateUrl: 'schedule.component.html',
  styleUrls: ['schedule.component.scss'],
})
export class ScheduleComponent implements OnInit {
  @Input() test;
  @Input() tests;
  daysOfWeek: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  hoursOfDay: string[] = [];
  colors = [
    '#007bff',
    '#6610f2',
    '#6f42c1',
    '#e83e8c',
    '#ff3d71',
    '#fd7e14',
    '#ffc107',
    '#28a745',
    '#20c997',
    '#17a2b8',
    '#6c757d',
    '#343a40',
  ];

  getColor(test) {
    if (this.test) {
      return 'var(--secondary)';
    }
    return this.colors[this.tests.findIndex(e => e.name === test) % this.colors.length];
  }

  events: any[] = [];

  constructor() {
    this.generateHours();
  }

  ngOnInit() {
    const events = this.tests.map(e => e.schedules?.map(d => {
      d.test = e.name;
      return d;
    })).flat() || [];
    this.events = _.groupBy(events.filter(e => e), a => a.day + '_' + a.time); // this.test.schedules || [];
  }

  generateHours() {
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const formattedHour = ('0' + hour).slice(-2);
        const formattedMinute = ('0' + minute).slice(-2);
        this.hoursOfDay.push(`${formattedHour}:${formattedMinute}`);
      }
    }
  }


  addEvent(time: string, day: string) {
    if (!this.test) {
      return;
    }
    if (this.events[day + '_' + time]?.find(e => e.test === this.test?.name)) {
      return;
    }
    const newEvent = {
      time: time,
      day: day,
      description: '',
      test: this.test?.name,
    };
    if (!this.events[day + '_' + time]) {
      this.events[day + '_' + time] = [];
    }
    this.events[day + '_' + time].push(newEvent);
    const events = Object.values(this.events).flat();
    if (this.test) {
      this.test.schedules = _.cloneDeep(events.filter(e => e.test === this.test.name));
      this.test.schedules.forEach(e => delete e.test);
    }
  }

  removeEvent(event, key, idx) {
    if (this.events[key][idx].test !== this.test?.name) {
      return;
    }
    event.stopPropagation();
    this.events[key].splice(idx, 1);
    const events = Object.values(this.events).flat();
    if (this.test) {
      this.test.schedules = _.cloneDeep(events.filter(e => e.test === this.test.name));
      this.test.schedules.forEach(e => delete e.test);
    }
  }
}
